import { render, staticRenderFns } from "./GoHomeBtn.vue?vue&type=template&id=42cacff2&"
import script from "./GoHomeBtn.vue?vue&type=script&lang=js&"
export * from "./GoHomeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports